import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ProgressBar from '@bibliocommons/shared-progress-bar';

const mapStateToProps = state => ({
  active: state.get('ui').get('progressBar')
});

const propTypes = {
  active: PropTypes.bool.isRequired
};

const GlobalProgressBarContainer = ({ active }) => <ProgressBar active={active} />;

GlobalProgressBarContainer.propTypes = propTypes;

export default connect(mapStateToProps)(GlobalProgressBarContainer);
